"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const lib_1 = require("../../../lib");
const CenterStack = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
  svg {
    height: 1rem !important;
  }
`;
const InlineButton = (0, app_1.styled)(ui_1.Button) `
  min-height: unset;
  height: unset;
  padding: unset;
  font-family: ${(theme) => theme.font};
`;
function Search({ setSearching, searching }) {
    const { t } = (0, app_1.useTranslation)();
    const { params } = (0, lib_1.useSearchMeta)();
    const { setParam } = (0, app_1.useRouter)();
    const handleSubmit = (0, react_1.useCallback)(({ search }) => __awaiter(this, void 0, void 0, function* () {
        yield setParam('search', search);
        setSearching(false);
        return ui_1.SubmitState.DO_NOT_CLEAR;
    }), [setParam, setSearching]);
    const handleClear = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        yield setParam('search', '');
        setSearching(false);
    }), [setParam, setSearching]);
    const handleClick = (0, react_1.useCallback)(() => void handleClear(), [handleClear]);
    if (searching) {
        return ((0, jsx_runtime_1.jsx)(ui_1.Form, Object.assign({ onSubmit: handleSubmit, contextOnly: true }, { children: (0, jsx_runtime_1.jsx)(ui_1.TextInput, { name: "search", placeholder: t('label.searchPlaceholder'), suffix: (0, jsx_runtime_1.jsxs)(ui_1.Stack, { children: [(0, jsx_runtime_1.jsx)(InlineButton, Object.assign({ kind: "transparent", onClick: handleClick }, { children: t('label.clearFliters') })), (0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, { onClick: () => setSearching(false) })] }), defaultValue: params.search }) })));
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ kind: "transparent", onClick: () => setSearching(true) }, { children: (0, jsx_runtime_1.jsxs)(CenterStack, Object.assign({ spacing: "0.1rem" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: t('label.search') })), (0, jsx_runtime_1.jsx)(svg_1.SvgSearch, {})] })) })));
}
exports.Search = Search;
